import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function deleteDeliveryAddress(deliveryId: number, reference: string | undefined) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    return shop
        .delete(getUrl(`/baskets/${reference}/delete/deliveryaddress/${deliveryId}`))
        .json<ShopTypes.BasketResponse>();
}
